import { postStat } from 'api/stats/stats.api'
import { proxy } from 'valtio'
import { subscribeKey } from 'valtio/utils'

const STORAGE_KEY_PREFERENCE = 'notificationCenter.useNewOptimizationLog'
const STORAGE_KEY_DISMISSED = 'notificationCenter.newOptLogTooltipDismissed'

type NotificationCenterStore = {
  useNewOptimizationLog: boolean
  tooltipDismissed: boolean
}

//TO BE REMOVED WHEN NEW OPTIMIZATION LOG IS FULLY RELEASED
const notificationCenterStore = proxy<NotificationCenterStore>({
  useNewOptimizationLog: localStorage.getItem(STORAGE_KEY_PREFERENCE) === 'true',
  tooltipDismissed: localStorage.getItem(STORAGE_KEY_DISMISSED) === 'true',
})

subscribeKey(notificationCenterStore, 'useNewOptimizationLog', (value) => {
  localStorage.setItem(STORAGE_KEY_PREFERENCE, JSON.stringify(value))
})

subscribeKey(notificationCenterStore, 'tooltipDismissed', (value) => {
  localStorage.setItem(STORAGE_KEY_DISMISSED, JSON.stringify(value))
})

export function setUseNewOptimizationLog(enabled: boolean): void {
  notificationCenterStore.useNewOptimizationLog = enabled
  postStat('notification-center-optimization-log', enabled ? 'user-enabled-new-log' : 'user-disabled-new-log')
}

export function dismissOptimizationLogTooltip(): void {
  notificationCenterStore.tooltipDismissed = true
}

export default notificationCenterStore
